import { connect } from "react-redux";

import { useEffect } from "react";

import { Tabla } from "../../../../../components/Table/Table";
import { Deudas } from "../Deudas/Deudas";


const columns = [
  {
    title: "RC",
    dataIndex: "rc",
    key: "rc",
  },
  {
    title: "NRO",
    dataIndex: "nro",
    key: "nro",
  },
  {
    title: "CONTRIBUYENTE",
    dataIndex: "nombre",
    key: "nombre",
  },
  {
    title: "Dirección",
    dataIndex: "address",
    key: "address",
  },
];

const Inmueble = ({ match, getInmueble, inmuebleData }) => {
  const { id } = match.params;

  useEffect(() => {
    if (id) {
      getInmueble(+id);
    }
  }, [id]);

  return (
    <>
      <div className="seccion-container">
        <h2 className="seccion-ttlo" style={{ marginBottom: 50 }}>Inmueble</h2>
        <Tabla dataList={inmuebleData ? [inmuebleData] : []} columns={columns} expandable={true} selection={false} RowData={Deudas} />
      </div>
    </>
  );
};


const mapStateToProps = (state) => {
  return {
    inmuebleData: state.dashboard.inmueble
  };
};

const mapDispatchToProps = () => {
  return;
};

export default connect(mapStateToProps, mapDispatchToProps)(Inmueble);